const STORAGE_KEY = 'aq_theme';

// SVG icons mirror the dashboard theme-toggle (DashboardHtmlUtils.kt) —
// single source of visual truth. Emoji-as-icon was flagged as anti-pattern
// by DESIGN.md line 115. Visibility is driven by [data-theme] in styles.css.
const ICONS_HTML =
  '<svg class="icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>' +
  '<svg class="icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>';

export function getTheme(): 'dark' | 'light' {
  return (localStorage.getItem(STORAGE_KEY) as 'dark' | 'light') || 'dark';
}

export function applyTheme(theme: 'dark' | 'light'): void {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(STORAGE_KEY, theme);
}

export function createThemeToggle(container: HTMLElement): void {
  const btn = document.createElement('button');
  btn.className = 'btn btn-sm theme-toggle-btn';
  btn.style.cssText = 'min-height: 36px; min-width: 36px; padding: 6px;';
  btn.setAttribute('aria-label', '\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0442\u0435\u043C\u0443');
  btn.innerHTML = ICONS_HTML;

  function updateTitle() {
    btn.title = getTheme() === 'dark' ? '\u0421\u0432\u0435\u0442\u043B\u0430\u044F \u0442\u0435\u043C\u0430' : '\u0422\u0451\u043C\u043D\u0430\u044F \u0442\u0435\u043C\u0430';
  }
  updateTitle();

  btn.addEventListener('click', () => {
    applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
    updateTitle();
  });

  container.appendChild(btn);
}
